// Disable noisy console methods in production on the client
const isProduction = process.env.NODE_ENV === 'production';

if (isProduction && typeof window !== 'undefined') {
  const noop = () => {};
  // Preserve originals for optional debugging through window.__originalConsole
  // eslint-disable-next-line no-underscore-dangle
  window.__originalConsole = {
    log: console.log,
    info: console.info,
    debug: console.debug,
    trace: console.trace,
    warn: console.warn,
    error: console.error
  };

  console.log = noop; // eslint-disable-line no-console
  console.info = noop; // eslint-disable-line no-console
  console.debug = noop; // eslint-disable-line no-console
  console.trace = noop; // eslint-disable-line no-console
}

export default null;





















